var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09115 13.4056V12.2725C4.09115 11.9108 4.23482 11.564 4.49054 11.3083C4.74627 11.0525 5.09311 10.9089 5.45476 10.9089H9.54558C9.90723 10.9089 10.2541 11.0525 10.5098 11.3083C10.7655 11.564 10.9092 11.9108 10.9092 12.2725V13.4056M14.3182 7.49985C14.3182 11.2653 11.2657 14.3179 7.50017 14.3179C3.73467 14.3179 0.682136 11.2653 0.682136 7.49985C0.682136 3.73436 3.73467 0.681824 7.50017 0.681824C11.2657 0.681824 14.3182 3.73436 14.3182 7.49985ZM9.54558 6.13625C9.54558 7.2659 8.62982 8.18166 7.50017 8.18166C6.37052 8.18166 5.45476 7.2659 5.45476 6.13625C5.45476 5.0066 6.37052 4.09084 7.50017 4.09084C8.62982 4.09084 9.54558 5.0066 9.54558 6.13625Z",
    stroke: "currentColor",
    strokeWidth: 1.36361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUser);
export default __webpack_public_path__ + "static/media/circle-user.68f3f51c.svg";
export { ForwardRef as ReactComponent };